/**
 * @generated SignedSource<<01cab51fa03d891e050b6a0e2b347724>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrgAdminGeneralUploadImageLinkMutation$variables = Record<PropertyKey, never>;
export type OrgAdminGeneralUploadImageLinkMutation$data = {
  readonly organisation: {
    readonly uploadImageLink: {
      readonly image: {
        readonly id: string;
      };
      readonly url: string;
    };
  };
};
export type OrgAdminGeneralUploadImageLinkMutation = {
  response: OrgAdminGeneralUploadImageLinkMutation$data;
  variables: OrgAdminGeneralUploadImageLinkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "OrgMutation",
    "kind": "LinkedField",
    "name": "organisation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UploadImageLinkResponse",
        "kind": "LinkedField",
        "name": "uploadImageLink",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "image",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgAdminGeneralUploadImageLinkMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "OrgAdminGeneralUploadImageLinkMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "ee6b0c4883e631284f0e0a87cb651898",
    "id": null,
    "metadata": {},
    "name": "OrgAdminGeneralUploadImageLinkMutation",
    "operationKind": "mutation",
    "text": "mutation OrgAdminGeneralUploadImageLinkMutation {\n  organisation {\n    uploadImageLink {\n      url\n      image {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5c5364ffda39cebfe56cddcd005b4d4e";

export default node;
